import { render, staticRenderFns } from "./whFooter.vue?vue&type=template&id=71bbfee9&"
import script from "./whFooter.vue?vue&type=script&lang=js&"
export * from "./whFooter.vue?vue&type=script&lang=js&"
import style0 from "./whFooter.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports